import { PerformancePeriod } from 'app/library/performance-period/models/performance-period.model';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { SimpleEntity } from 'app/projects/shared/src/lib/models/simple-entity.model';
import { IPerformanceTeamReviewActionPayload } from '../interfaces/create-performance-team-review.interface';
import { PerformanceTeamMemberOverview } from '../models/performance-team-member-overview.model';
import { PerformanceTeamOverview } from '../models/performance-team-overview.model';
import { PerformanceTeamReview } from '../models/performance-team-review.model';

export class SetPerformanceTeamReview {
    static readonly type = '[PerformanceTeamReview] SetPerformanceTeamReview';

    constructor(public payload: PerformanceTeamReview) {}
}

export class UnsetPerformanceTeamReview {
    static readonly type = '[PerformanceTeamReview] UnsetPerformanceTeamReview';
}

export class FetchPerformanceTeamReview {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamReview';

    constructor(public payload: string) {}
}

export class FetchPerformanceTeamReviewSuccess {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamReviewSuccess';

    constructor(public payload: PerformanceTeamReview) {}
}

export class FetchPerformanceTeamReviewFailure {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamReviewFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreatePerformanceTeamReview {
    static readonly type = '[PerformanceTeamReview] CreatePerformanceTeamReview';

    constructor(public payload: IPerformanceTeamReviewActionPayload) {}
}

export class CreatePerformanceTeamReviewSuccess {
    static readonly type = '[PerformanceTeamReview] CreatePerformanceTeamReviewSuccess';

    constructor(public payload: PerformanceTeamReview) {}
}

export class CreatePerformanceTeamReviewFailure {
    static readonly type = '[PerformanceTeamReview] CreatePerformanceTeamReviewFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdatePerformanceTeamReview {
    static readonly type = '[PerformanceTeamReview] UpdatePerformanceTeamReview';

    constructor(public payload: { performanceTeamReviewId: string; performanceTeamReview: IPerformanceTeamReviewActionPayload }) {}
}

export class UpdatePerformanceTeamReviewSuccess {
    static readonly type = '[PerformanceTeamReview] UpdatePerformanceTeamReviewSuccess';

    constructor(public payload: PerformanceTeamReview) {}
}

export class UpdatePerformanceTeamReviewFailure {
    static readonly type = '[PerformanceTeamReview] UpdatePerformanceTeamReviewFailure';

    constructor() {}
}

export class DeletePerformanceTeamReview {
    static readonly type = '[PerformanceTeamReview] DeletePerformanceTeamReview';

    constructor(public payload: string) {}
}

export class DeletePerformanceTeamReviewSuccess {
    static readonly type = '[PerformanceTeamReview] DeletePerformanceTeamReviewSuccess';

    constructor(public payload: string) {}
}

export class DeletePerformanceTeamReviewFailure {
    static readonly type = '[PerformanceTeamReview] DeletePerformanceTeamReviewFailure';

    constructor(public payload: string) {}
}

export class SetPerformanceTeamReviews {
    static readonly type = '[PerformanceTeamReview] SetPerformanceTeamReviews';

    constructor(public payload: PerformanceTeamReview[]) {}
}

export class FetchPerformanceTeamReviews {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamReviews';

    constructor(
        public payload?: {
            teamId: string;
            pageSize?: number;
            pageNumber?: number;
            search?: string;
            type?: string;
            periodUnderReview?: string;
            goalSettingPeriod?: string;
            userId?: string;
        }
    ) {}
}

export class FetchPerformanceTeamReviewsSuccess {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamReviewsSuccess';
}

export class FetchPerformanceTeamReviewsFailure {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamReviewsFailure';
}

export class SearchPerformanceTeamReviews {
    static readonly type = '[PerformanceTeamReview] SearchPerformanceTeamReviews';

    constructor(public payload: string) {}
}

export class FetchPerformanceTeamOverveview {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamOverveview';

    constructor(public payload: string) {}
}

export class FetchPerformanceTeamOverveviewSuccess {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamOverveviewSuccess';

    constructor(public payload: PerformanceTeamOverview) {}
}

export class FetchPerformanceTeamOverveviewFailure {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamOverveviewFailure';

    constructor() {}
}

export class FetchPerformanceTeamMemberOverveview {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamMemberOverveview';

    constructor(public payload: { teamId: string; userId: string }) {}
}

export class FetchPerformanceTeamMemberOverveviewSuccess {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamMemberOverveviewSuccess';

    constructor(public payload: PerformanceTeamMemberOverview[]) {}
}

export class FetchPerformanceTeamMemberOverveviewFailure {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamMemberOverveviewFailure';

    constructor() {}
}

export class FetchAvailablePerformanceTeamTemplateTypes {
    static readonly type = '[PerformanceTeamReview] FetchAvailablePerformanceTeamTemplateTypes';

    constructor(public payload: string) {}
}

export class FetchAvailablePerformanceTeamTemplateTypesSuccess {
    static readonly type = '[PerformanceTeamReview] FetchAvailablePerformanceTeamTemplateTypesSuccess';

    constructor(public payload: SimpleEntity[]) {}
}

export class FetchAvailablePerformanceTeamTemplateTypesFailure {
    static readonly type = '[PerformanceTeamReview] FetchAvailablePerformanceTeamTemplateTypesFailure';

    constructor() {}
}

export class FetchPerformanceTeamTemplateTypes {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamTemplateTypes';

    constructor(public payload: string) {}
}

export class FetchPerformanceTeamTemplateTypesSuccess {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamTemplateTypesSuccess';

    constructor(public payload: SimpleEntity[]) {}
}

export class FetchPerformanceTeamTemplateTypesFailure {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamTemplateTypesFailure';

    constructor() {}
}

export class FetchPerformanceTeamPeriods {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamPeriods';

    constructor(public payload: string) {}
}

export class FetchPerformanceTeamPeriodsSuccess {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamPeriodsSuccess';

    constructor(public payload: PerformancePeriod[]) {}
}

export class FetchPerformanceTeamPeriodsFailure {
    static readonly type = '[PerformanceTeamReview] FetchPerformanceTeamPeriodsFailure';
}

export class UpdatePerformanceTeamParticipants {
    static readonly type = '[PerformanceTeamReview] UpdatePerformanceTeamParticipants';

    constructor(public payload: { teamReviewId: string; userIds: string[] }) {}
}

export class UpdatePerformanceTeamParticipantsSuccess {
    static readonly type = '[PerformanceTeamReview] UpdatePerformanceTeamParticipantsSuccess';

    constructor(public payload: PerformanceTeamReview) {}
}

export class UpdatePerformanceTeamParticipantsFailure {
    static readonly type = '[PerformanceTeamReview] UpdatePerformanceTeamParticipantsFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}
